import React, { useEffect, useState } from "react";
import { useAuth } from "../AuthContext";
import SEO from "../components/SEO";

export default function AdminPortal() {
  const { user } = useAuth();
  const [iframeUrl, setIframeUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Determine the base URL for the merchant admin app
    const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    const baseUrl = isLocal ? "http://localhost:3001" : "https://trivanamerchant.com";

    // If we have SSO credentials in active session, pass them as query parameters
    const sso = user?.merchantSso;
    if (sso && sso.token) {
      setIframeUrl(
        `${baseUrl}/?sso_token=${encodeURIComponent(sso.token)}&sso_email=${encodeURIComponent(sso.email)}&sso_role=${encodeURIComponent(sso.role)}`
      );
    } else {
      setIframeUrl(baseUrl);
    }
  }, [user]);

  return (
    <div className="w-full bg-gray-50 flex flex-col" style={{ height: "calc(100vh - 68px)" }}>
      <SEO
        title="Admin Portal - Trivana"
        description="Access your Trivana merchant dashboard and manage operations."
        url="/admin"
      />
      
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/70 backdrop-blur-sm z-10" style={{ top: "68px" }}>
          <div className="text-center">
            <div className="inline-block w-12 h-12 rounded-full border-4 border-blue-600 border-t-transparent animate-spin mb-4" />
            <p className="text-sm font-semibold text-gray-700" style={{ fontFamily: "Montserrat, sans-serif" }}>
              Loading Admin Portal...
            </p>
            <p className="text-xs text-gray-400 mt-1">Establishing secure connection</p>
          </div>
        </div>
      )}

      {iframeUrl && (
        <iframe
          src={iframeUrl}
          title="Trivana Admin Portal"
          className="w-full h-full border-none"
          onLoad={() => setIsLoading(false)}
          allow="geolocation; microphone; camera; midi; encrypted-media;"
        />
      )}
    </div>
  );
}
